<template>
  <div class="sso-callback">
    <div class="shadow-box pa-4 text-center">
      <img src="~@images/logo.svg" class="logo">

      <v-row v-if="loading">
        <v-col>
          <v-progress-circular indeterminate color="primary" size="48" class="my-6" />
          <p>{{ $t('sso.login-in-progress') }}</p>
        </v-col>
      </v-row>

      <v-row v-if="error">
        <v-col>
          <v-alert outlined class="my-10" type="error">{{ error }}</v-alert>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import SSORepository from "@repository/SSORepository";

export default {
  data() {
    return {
      loading: true,
      error: null,
    }
  },

  mounted() {
    this.handleTokenLogin()
  },

  methods: {
    handleTokenLogin() {
      const slug = this.$route.params.slug
      const token = this.$route.query.token

      if (!slug || !token) {
        this.loading = false
        this.error = this.$t('sso.token-login-missing-params')
        return
      }

      SSORepository.tokenLogin({ token, provider: slug }).then(() => {
        this.$auth.setAuthenticated(true)
        this.$router.replace({ name: 'dashboard' })
      }).catch(e => {
        this.loading = false
        const errorCode = e.response?.data?.error
        if (errorCode && this.$te('sso.error.' + errorCode)) {
          this.error = this.$t('sso.error.' + errorCode)
        } else {
          this.error = e.response?.data?.message || this.$t('sso.login-error')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sso-callback {
  justify-content: center;
  .shadow-box {
    width: 40.404vw;
    min-width: 400px;
    @media only screen and (max-width: 600px) {
      width: 100%;
      min-width: 100%;
    }
    .logo {
      width: 23.232vw;
      @media only screen and (max-width: 600px) {
        width: 80%;
      }
    }
  }
}
</style>
